module.exports = __webpack_public_path__ + "public/img/shebeilianwangtaishu.834a38e6.png";